// extracted by mini-css-extract-plugin
module.exports = {"container":"LabNav_container__2QWhO","leftsideButtons":"LabNav_leftsideButtons__3t8JF","rightsideButtons":"LabNav_rightsideButtons__qs2RN"};